export function getValueFromPath(obj, path) {
    if (!obj || !path) {
        return '';
    }
    const parts = path.split('.');
    return parts.reduce((current, key) => {
        if (current === undefined || current === null)
            return undefined;
        const match = key.match(/^([^[\]]+)(\[(\d+)\])?$/);
        if (!match)
            return undefined;
        const prop = match[1];
        const index = match[3] !== undefined ? parseInt(match[3], 10) : undefined;
        const next = current[prop];
        return index !== undefined ? next === null || next === void 0 ? void 0 : next[index] : next;
    }, obj);
}
export const mapButtonTypeToIconName = (type, iconNameFromConfig) => {
    let iconName = '';
    if (type === 'WarrantyTypePlus') {
        return iconName;
    }
    switch (type) {
        case 'custom':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'info-circle';
            break;
        case 'contact':
        case 'nws':
        case 'bevAgency':
        case 'leasing':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'direct-mail';
            break;
        case 'ecom':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'commute';
            break;
        case 'liveDemo':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'delivery';
            break;
        case 'liteReservation':
        case 'reserve':
        case 'reservation':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'mileage';
            break;
        case 'dealer':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'my-dealer';
            break;
        case 'financeInfo':
        case 'finance-checkout':
        case 'financeOptions':
        case 'glc-cash-checkout':
        case 'glc-financing-checkout':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'commute';
            break;
        case 'phone':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'voice-call';
            break;
        case 'central-customer-hotline':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'hotline';
            break;
        case 'details':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'info-circle';
            break;
        case 'whatsapp':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'whatsapp';
            break;
        case 'ConsumptionDisplay':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'consumption';
            break;
        case 'WarrantyTypeNap':
        case 'WarrantyTypeCpo':
        case 'WarrantyTypeAsgExtended':
        case 'WarrantyTypeAsg':
        case 'WarrantyTypeWarranty':
        case 'WarrantyTypePlus':
        case 'WarrantyType12Months':
        case 'WarrantyType5Years':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'warranty';
            break;
        case 'EmissionDisplay':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'co2-emission';
            break;
        case 'Mileage':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'mileage';
            break;
        case 'GearType':
        case 'GearBox':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'transmission';
            break;
        case 'FuelType':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'fuel-station';
            break;
        case 'InitialRegistrationDate':
        case 'ProductionYear':
        case 'SalesModelYear':
        case 'ModelYear':
        case 'VehicleInspectionDueDate':
        case 'GeneralInspection':
        case 'WarrantyExpiryDate':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'calendar-events';
            break;
        case 'ElectricRange':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'electric-range';
            break;
        case 'ExtColor':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== '' ? iconNameFromConfig : 'car';
            break;
        case 'UpholsteryType':
        case 'UpholsteryColor':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'interior-configuration';
            break;
        case 'PowerDisplay':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'power';
            break;
        case 'DriveType':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'quattro';
            break;
        case 'NumPreviousOwners':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'groups';
            break;
        case 'TopSpeed':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== ''
                    ? iconNameFromConfig
                    : 'top-speed';
            break;
        case 'RegistrationPlate':
            iconName =
                iconNameFromConfig !== undefined && iconNameFromConfig !== '' ? iconNameFromConfig : 'car';
            break;
        default:
            iconName = 'info-circle';
    }
    return iconName;
};
export const handleChangeAllCarlineModels = (applyFilters, filterData, carlineGroupCheckboxMembers, allCarlineModelsAreChecked, setAllCarlineModelsAreChecked, carlineGroup, carlineGroupName, filterCategory, isPlpQuickFilters) => {
    var _a, _b;
    const filterDTOs = [];
    const filterCarlineData = (_b = (_a = filterData === null || filterData === void 0 ? void 0 : filterData.groups) === null || _a === void 0 ? void 0 : _a.carline) === null || _b === void 0 ? void 0 : _b.members;
    carlineGroupCheckboxMembers.forEach((carlineGroupCheckboxMember) => {
        var _a;
        const carlineHasAvailableCars = ((_a = filterCarlineData[carlineGroupCheckboxMember]) === null || _a === void 0 ? void 0 : _a.count) > 0;
        const filterDTO = {
            id: carlineGroupCheckboxMember,
            active: !allCarlineModelsAreChecked,
        };
        return carlineHasAvailableCars && filterDTOs.push(filterDTO);
    });
    const currentFilter = { id: carlineGroup, values: [] };
    const componentName = isPlpQuickFilters ? 'vtp quick filter' : 'vtp filter';
    const trackingEventName = !allCarlineModelsAreChecked
        ? `${componentName} - add filter`
        : `${componentName} - remove filter`;
    const trackingData = {
        trackingEventName,
        trackingLabel: carlineGroupName,
        trackingValue: filterCategory,
        changedFilter: [currentFilter],
    };
    setAllCarlineModelsAreChecked(!allCarlineModelsAreChecked);
    applyFilters(filterDTOs, trackingData);
};
export * from './AlphaHelper';
export const matchesKeyForVtp = (imageKey, hasVtp4x3m1c) => {
    return hasVtp4x3m1c
        ? imageKey.startsWith('vtp4x3m')
        : imageKey.startsWith('vtp4x3n') || imageKey.startsWith('vtp4x3i');
};
export const resolvePlaceholder = (templateString, dataObject) => {
    if (!templateString)
        return null;
    const regex = /{{\s*([^}]+)\s*}}/g;
    return templateString.replace(regex, (_, keyPath) => {
        const keys = keyPath.split('.');
        let value = dataObject;
        for (const key of keys) {
            if (value && typeof value === 'object' && key in value) {
                value = value[key];
            }
            else {
                return `{{${keyPath}}}`;
            }
        }
        return value;
    });
};
